import { View } from "shark-mvc";

class ViewBase extends View {
	constructor (name) {
		super(name);
	}

	getFiltersStatus () {
		const filtersStatus = localStorage.getItem(`${this.className}FiltersStatus`);

		if (filtersStatus) {
			return JSON.parse(filtersStatus);
		}
		else {
			return null;
		}
	}

	saveFiltersStatus (filters) {
		// console.log("Salverei", filters.export(), "per", this.className);
		localStorage.setItem(`${this.className}FiltersStatus`, JSON.stringify(filters.export()));
		return true;
	}

	//Dave: Bello, ma devo gestire l'aggiunta dei listener sugli ancestor
	singleItemBox_clickHandler (event, data) {
		if (event.target.closest(".preventRowClick") !== null) {
			return;
		}
		if (event.target.classList.contains("notClickable")) {
			return;
		}

		if (this.singleItemClick) {
			this.singleItemClick(data);
		}
	}

}

export default ViewBase;
